export const DEFAULT_TIME_ENTRY_VALUE = '0:00';
export const DEFAULT_TIME_ENTRY_SECONDS = 0;
export const TIME_ENTRY_ANIMATION_DURATION = 800;
export const HIGHLIGHT_INPUT_ERROR_WAIT = 150;
export const TIME_ENTRY_MODAL_CLOSED_EVENT = 'scoro-time-entry-modal-closed';

export const TRACKING_SUCCESS_MIN_MS = 1800;
export const TRACKING_SUCCESS_FADE_MS = 300;
export const TRACKING_SUCCESS_MAX_WAIT_MS = 120000;
export const OPTIMISTIC_TRACKING_CLEAR_MS = 15000;
